/** 题库题目中与图片有关的 JSON URL 字段解析（后端存 JSON 字符串数组）。 */

export function parseUrlList(jsonStr) {
  if (jsonStr == null || jsonStr === '') return []
  try {
    const arr = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr
    if (!Array.isArray(arr)) return []
    return arr.map((x) => String(x || '').trim()).filter(Boolean)
  } catch (e) {
    return []
  }
}

/** 选择题选项附图字段名映射 */
export function optionImageProp(key) {
  const k = String(key || '').toUpperCase()
  const map = {
    A: 'optionAImage',
    B: 'optionBImage',
    C: 'optionCImage',
    D: 'optionDImage'
  }
  return map[k] || ''
}

export function resolveOptionImage(question, optKey) {
  const prop = optionImageProp(optKey)
  if (!prop || !question) return ''
  return question[prop] ? String(question[prop]) : ''
}

/** 答卷详情等场景：从 options JSON + 行上的 optionXImage 拼出选项列表 */
export function optionEntriesFromRow(row) {
  let obj = {}
  try {
    obj = row && row.options ? JSON.parse(row.options) : {}
  } catch (e) {
    obj = {}
  }
  const keys = Object.keys(obj)
  if (!keys.length) {
    return ['A', 'B', 'C', 'D']
      .map((k) => ({ key: k, value: '', imageUrl: resolveOptionImage(row, k) }))
      .filter((x) => x.imageUrl)
  }
  return keys.map((k) => ({
    key: k,
    value: obj[k] != null ? String(obj[k]) : '',
    imageUrl: resolveOptionImage(row, k)
  }))
}
